import React, { useMemo } from 'react';
import classNames from 'classnames';
import type { AwModeState } from '@components/Modals/ApprovalModal/ApprovalModal/ApprovalModal';
import { ArrowRightWithoutLineIcon, CheckTaskIcon } from '@icons';
import './Steps.less';

type StepsProps = {
  currentStep: StepItemKey;
  awMode: AwModeState;
  completedSteps: StepItemKey[];
  onChangeStep: (value: StepItemKey) => void;
};

export type StepItemKey =
  | 'creatingApproval'
  | 'media'
  | 'stages'
  | 'settings'
  | 'finalReview';

type StepItem = {
  title: string;
  key: StepItemKey;
  status: 'wait' | 'process' | 'finish';
};

export default function Steps({
  currentStep,
  awMode,
  completedSteps,
  onChangeStep
}: StepsProps) {
  const stepsItems: StepItem[] = useMemo(() => {
    const steps: StepItem[] = [
      {
        title: awMode === 'edit' ? 'Edit approval' : 'Creating approval',
        key: 'creatingApproval',
        status: 'wait'
      },
      {
        title: 'Media',
        key: 'media',
        status: 'wait'
      },
      {
        title: 'Stages',
        key: 'stages',
        status: 'wait'
      },
      {
        title: 'Settings',
        key: 'settings',
        status: 'wait'
      },
      {
        title: 'Final review',
        key: 'finalReview',
        status: 'wait'
      }
    ];
    const currentIndex = steps.findIndex((step) => step.key === currentStep);

    return steps.map((step, index) => {
      if (index === currentIndex) return { ...step, status: 'process' };
      if (index < currentIndex || completedSteps.includes(step.key))
        return { ...step, status: 'finish' };
      return { ...step, status: 'wait' };
    });
  }, [currentStep, completedSteps, awMode]);

  const onClickStep = (item: StepItem) => {
    if (item.status === 'wait') return;
    onChangeStep(item.key);
  };

  return (
    <div className="handle-approval-modal-steps">
      {stepsItems.map((item, index) => (
        <div
          className={classNames(
            'handle-approval-modal-steps-item',
            `b-step-${item.status}`
          )}
          key={index}
          onClick={() => onClickStep(item)}
        >
          {item.title}
          {item.status === 'finish' && <CheckTaskIcon />}
          <ArrowRightWithoutLineIcon className="handle-approval-modal-steps-icon-separate" />
        </div>
      ))}
    </div>
  );
}
